import {inject, singleton} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {Employee} from "../../domain/entities/employee.entity";
import {MessageBroker} from "../../message-broker/message-broker";
import {EntityChangedPayload} from "../../message-broker/payloads/entity-changed.payload";
import {CommandBus} from "../../services/command-bus.service";
import {RenameEmployeeCommand} from "../rename-employee.command";
import {ICommandHandler} from "./i-command.handler";

@CommandHandler(RenameEmployeeCommand)
@singleton()
export class RenameEmployeeCommandHandler implements ICommandHandler<Employee> {

    constructor(
        @inject(CommandBus) private readonly _commandBus: CommandBus,
        @inject(MessageBroker) private readonly _messageBroker: MessageBroker,
    ) {
    }

    public async handle(command: RenameEmployeeCommand): Promise<void> {
        if (!(await this._commandBus.addSendCommand(command))) {
            return;
        }

        const employee = command.payload;

        this._messageBroker.publish<EntityChangedPayload<Employee>>({
            type: `entity.changed`,
            identityHash: employee.uid,
            payload: {
                uid: employee.uid,
                prototype: Employee,
                changeSet: employee.changeSet
            }
        });

        employee.markAsPersisted();
    }
}